'use strict';

exports.__esModule = true;
exports.default = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Facebook = require('./Facebook');

var _Facebook2 = _interopRequireDefault(_Facebook);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var facebookInstance = null;

var Facebook = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Facebook, _Component);

  function Facebook() {
    (0, _classCallCheck3.default)(this, Facebook);
    return (0, _possibleConstructorReturn3.default)(this, _Component.apply(this, arguments));
  }

  Facebook.prototype.getChildContext = function getChildContext() {
    return {
      facebook: this
    };
  };

  Facebook.prototype.init = function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      var _props, _domain, _version, _appId, _cookie, _status, _xfbml, _language, _frictionlessRequests, _wait;

      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!this.facebook) {
                _props = this.props, _domain = _props.domain, _version = _props.version, _appId = _props.appId, _cookie = _props.cookie, _status = _props.status, _xfbml = _props.xfbml, _language = _props.language, _frictionlessRequests = _props.frictionlessRequests, _wait = _props.wait;


                this.facebook = facebookInstance || new _Facebook2.default({
                  domain: _domain,
                  appId: _appId,
                  version: _version,
                  cookie: _cookie,
                  status: _status,
                  xfbml: _xfbml,
                  language: _language,
                  frictionlessRequests: _frictionlessRequests,
                  wait: _wait
                });

                facebookInstance = this.facebook;
              }

              _context.next = 3;
              return this.facebook.init();

            case 3:
              return _context.abrupt('return', this.facebook);

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function init() {
      return _ref.apply(this, arguments);
    }

    return init;
  }();

  Facebook.prototype.render = function render() {
    return this.props.children;
  };

  return Facebook;
}(_react.Component), _class.childContextTypes = {
  facebook: _propTypes2.default.object.isRequired
}, _class.defaultProps = {
  version: 'v2.9',
  cookie: false,
  status: false,
  xfbml: false,
  language: 'en_US',
  frictionlessRequests: false,
  domain: 'connect.facebook.net',
  children: undefined,
  wait: false
}, _temp);
exports.default = Facebook;
//# sourceMappingURL=FacebookProvider.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-facebook/lib/FacebookProvider.js
// module id = 711
// module chunks = 198517197184460